import React from 'react';
import ArchyModal from 'components/shell/ArchyModal';

/** Large list pop-up (e.g. Incomplete projects). Uses the shared UI refresh frame (Aaron, 5 Nov 2026). */
type Props = {
  title: string;
  children: React.ReactNode;
  exit(): void;
};

export const Dialog: React.FC<Props> = ({ title, children, exit }) => (
  <ArchyModal title={title} onClose={exit} width={960}>
    <div style={{ padding: '8px 12px 16px' }}>{children}</div>
  </ArchyModal>
);
